function zero(number) {
    return number < 10 ? `0${number}` : number
}
const now = new Date()

const date = {
    dateTimeBr: (date) => {
        date = date ? new Date(date) : now
        return date.toISOString().slice(0, 10).split('-').reverse().join('/') + ' ' + date.getHours() + ':' + zero(date.getMinutes())
    },
    dateTime: () => {
        return `${now.getFullYear()}-${zero(now.getMonth() + 1)}-${zero(now.getDay())}T${now.getHours()}:${zero(now.getMinutes())}:${zero(now.getSeconds())}`
    },
    eua: (date) => {
        return date.split('/').reverse().join('-')
    }
}

export default date
